<template>
  <div class="card mt-1 no-mobile">
    <div class="table-controls m-3">
      <div class="controls-wrap d-flex">
        <!-- Integration Field -->

        <!--         <Search
          placeholderText="Search (title and description)"
          @show-filter="toggleFilter = true"
          @close-filter="toggleFilter = false"
          @search="doSearch"
        /> -->

        <input
          type="search"
          id="integration-search"
          class="form-control mr-2"
          aria-label="SearchGrid"
          aria-describedby="searchGrid"
          placeholder="Search (title and description)"
          v-model="searchWord"
          @input="checkSearch"
          @keyup.enter="doSearch(searchWord)"
        />

        <button
          style="align-self: flex-start"
          class="btn btn-outline mr-4"
          type="button"
          @click="addFilter((input = {}), filters)"
        >
          <i class="fas fa-plus-circle"></i>
        </button>

        <div class="d-flex align-items-start">
          <div class="empl">
            <v-select
              @input="handleSearchFilters"
              v-model="isPublished"
              placeholder="Status"
              inputId="published-promoted-select"
              :options="['Published', 'Promoted']"
              :reduce="status => status"
              :clearable="false"
              multiple
            />
          </div>

          <!-- Employer -->
          <div class="empl">
            <v-select
              v-if="getEmployersDropdown"
              v-model="listOfSelectedEmployers"
              @input="handleSearchFilters"
              :options="getEmployersDropdown"
              placeholder="All Employers"
              inputId="employer-select"
              label="name"
              :reduce="employer => employer"
              :clearable="false"
              multiple
            />
          </div>
          <div class="empl">
            <v-select
              @input="handleSearchFilters"
              v-model="serviceLevelSelectModel"
              placeholder="Service level"
              inputId="service-level-select"
              :options="[
                { id: 0, service: 'Basic' },
                { id: 1, service: 'Sourcing' },
                { id: 2, service: 'Full-service' },
                { id: 3, service: 'Nearshore' },
                { id: 4, service: 'Freelancers' },
              ]"
              label="service"
              :reduce="service => service"
              :clearable="false"
              multiple
            />
          </div>
        </div>

        <!-- Add Job btn -->
        <router-link
          :to="{ name: 'add-job-mobile' }"
          type="button"
          class="ml-auto btn btn-success text-nowrap m-button"
        >
          Add Job
        </router-link>
        <button
          type="button"
          class="ml-auto btn btn-success text-nowrap desktop-only"
          @click="showModal = true"
        >
          Add Job
          <portal to="add-job-modal">
            <CustomMainModal @close="onCloseAddJobModal" v-show="showModal">
              <template v-slot:header>
                <h5>Add Job</h5>
              </template>
              <AddJobBtnModal v-if="showModal" />
            </CustomMainModal>
          </portal>
        </button>
      </div>

      <!-- FILTERS -->
      <section class="filter-items">
        <div class="row mt-3">
          <div
            v-for="(input, index) in filters"
            :key="`phoneInput-${index}`"
            class="col-md-8 filter"
          >
            <div class="d-flex">
              <select
                @change="selectedFilterType"
                name="select-filter"
                class="form-control filter-select"
                v-model="selectedFilterName[index]"
              >
                <option value="location">Location</option>
                <option value="distance">City (distance)</option>
                <option value="employment">Employment type</option>
                <option value="competences">Competencies</option>
                <option value="relocation">Relocation</option>
              </select>

              <v-select
                v-if="selectedFilterName[index] == 'location'"
                @input="handleVSelectFields($event, selectedFilterName)"
                @search="fetchOptions"
                v-model="input['location']"
                class="mr-1 w-100"
                label="name"
                placeholder="Location"
                aria-label="location"
                aria-describedby="location-input"
                :options="[...locationsOptions]"
                :reduce="location => location"
                :clearable="false"
                multiple
              >
                <template v-slot:no-options>
                  <div style="opacity: 0.5">Please type at least 3 characters</div>
                </template>
              </v-select>

              <v-select
                v-if="selectedFilterName[index] == 'distance'"
                @change="handleVSelectFields($event, selectedFilterName)"
                @search="fetchOptionsForCities"
                v-model="input['city']"
                class="mr-1 w-100"
                inputId="city-distance"
                label="name"
                placeholder="City name"
                aria-label="city-distance"
                aria-describedby="city-distance-input"
                :options="citiesByNameOptions"
                :reduce="city => city"
                :clearable="false"
                autocorrect="off"
                spellcheck="false"
                autocomplete="off"
              >
                <template v-slot:no-options>
                  <div style="opacity: 0.5">Please type at least 3 characters</div>
                </template>
              </v-select>

              <input
                v-if="selectedFilterName[index] == 'distance'"
                v-model="input['distance']"
                @input="toggleLabel($event)"
                type="text"
                id="distance"
                name="distance"
                style="max-width: 145px; min-width: 145px"
                class="form-control mr-1"
                aria-describedby="CityDistanceHelp"
                placeholder="Distance (km)"
              />

              <label
                v-if="selectedFilterName[index] == 'distance' && showLabel"
                class="custom-label"
                for="distance"
                >km</label
              >

              <select
                v-if="selectedFilterName[index] == 'employment'"
                @input="handleVSelectFields($event, selectedFilterName)"
                class="form-control w-100"
                name="employment"
                v-model="input['employment']"
              >
                <option value="1">Employment</option>
                <option value="2">Self-employment</option>
                <!-- <option value="3">Employment / Self-Employment</option> -->
              </select>

              <v-select
                v-if="selectedFilterName[index] == 'competences'"
                @input="handleVSelectFields($event, selectedFilterName)"
                v-model="input['competences']"
                class="w-100 mr-1"
                placeholder="Competencies"
                label="name"
                :options="[...getCompetencesFilterList]"
                :reduce="competence => competence.id"
                :clearable="false"
                multiple
              >
                <template v-slot:no-options>
                  <div style="opacity: 0.5">Sorry, no matching competence</div>
                </template>
              </v-select>

              <select
                v-if="selectedFilterName[index] == 'serviceLevel'"
                class="form-control mr-0"
                v-model="input['serviceLevel']"
                @input="handleVSelectFields($event, selectedFilterName)"
                name="service-level"
              >
                <option>Basic</option>
                <option>Sourcing</option>
                <option>Full-service</option>
              </select>

              <select
                v-if="selectedFilterName[index] == 'relocation'"
                @input="handleVSelectFields($event, selectedFilterName)"
                class="form-control"
                v-model="input['relocation']"
                name="relocation"
              >
                <option :value="false">No</option>
                <option :value="true">Yes</option>
              </select>

              <button
                class="btn btn-outline-remove"
                type="button"
                @click="removeSingleFilter(index, filters)"
              >
                <i class="fas fa-times-circle"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="row" v-show="filters.length > 0">
          <div class="col-md-8 d-flex filter">
            <div class="ml-auto">
              <button
                type="button"
                class="btn btn-success text-nowrap text-white mt-2 mr-1"
                @click="applyFilters"
                :disabled="isApplyFiltersDisabled"
              >
                Apply Filters
              </button>
              <button
                type="button"
                class="btn btn-danger text-nowrap text-white mt-2 mr-1"
                @click="removeAllFilters"
              >
                Remove Filters
              </button>
              <button
                class="btn btn-outline mt-2"
                type="button"
                @click="addFilter((input = {}), filters)"
              >
                <i class="fas fa-plus-circle"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- END FILTERS -->
    </div>
    <div class="table-responsive" v-on:scroll.passive="handleScroll" style="height: 100%">
      <Spinner :isLoading="isLoading" />
      <table class="table table-striped custom-table">
        <thead class="bg-dark">
          <tr>
            <th id="col-title" :style="stylesObj" style="width: 240px" scope="col" nowrap>TITLE</th>
            <th :style="{ display: isVisible }" nowrap scope="col">EMPLOYER</th>
            <th nowrap style="width: 180px" scope="col">LOCATION</th>
            <th nowrap style="width: 80px; text-align: center" scope="col">&nbsp;</th>
            <th nowrap style="width: 80px; text-align: center" scope="col">&nbsp;</th>
            <th nowrap scope="col">UPDATED</th>
            <th nowrap scope="col">STATUS</th>
            <th nowrap scope="col">PIPELINE STATISTICS</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="jobAd in getJobAds" :key="jobAd.uuid">
            <td id="title" nowrap>
              <div class="truncate-item">
                <div slot="reference">
                  <router-link :title="jobAd.title" :to="getRouteByRole(getAccType, jobAd)">
                    {{ jobAd.title }}
                  </router-link>
                </div>
              </div>
            </td>
            <td :style="{ display: isVisible }" id="employer" nowrap>
              <div class="text-truncate" slot="reference">
                <router-link
                  :to="{
                    name: 'employer_id',
                    params: {
                      employer_id: jobAd.js_employer_id,
                      employer_name: jobAd.employer_name,
                    },
                  }"
                  >{{ jobAd.employer_name }}</router-link
                >
              </div>
            </td>
            <td id="location" nowrap style="overflow: hidden; text-overflow: ellipsis">
              {{ getLocation(jobAd.city, jobAd.country) }}
            </td>

            <td nowrap id="promoted">
              <!-- <router-link to>
                <svgHelper
                  @click.native="changePromotedState"
                  :title="promotedState ? 'Promoted' : 'Not Promoted'"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :style="{
                    width: '20px',
                    height: '20px',
                    fill: jobAd.promoted ? '#f05a00' : '#a7a7a7',
                  }"
                  name="promoted"
                />
              </router-link> -->
              <svgHelper
                :title="jobAd.promoted ? 'Promoted' : 'Not Promoted'"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                :style="{
                  width: '20px',
                  height: '20px',
                  fill: jobAd.promoted ? '#f05a00' : '#a7a7a7',
                }"
                name="promoted"
              />
            </td>

            <td id="service-level" class="p-0" nowrap>
              <div class="popover-show mx-auto" style="width: 25px; height: auto">
                <svgHelper
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :title="serviceLevel(jobAd.service_level).title"
                  :name="serviceLevel(jobAd.service_level).title"
                />
              </div>
            </td>

            <td nowrap id="updated-at">
              <popper
                trigger="hover"
                :options="{
                  placement: 'top',
                  modifiers: { offset: { offset: '-60,10px' } },
                }"
              >
                <div class="popper">
                  {{
                    jobAd.updated_at
                      | formatDate({
                        format: getUserProfile.format_date,
                        timezone: getUserProfile.timezone,
                        hasHourAndMinutes: true,
                      })
                  }}
                </div>
                <div slot="reference">
                  {{
                    jobAd.updated_at
                      | formatDate({
                        format: getUserProfile.format_date,
                        timezone: getUserProfile.timezone,
                        hasHourAndMinutes: false,
                      })
                  }}
                </div>
              </popper>
            </td>

            <td id="status" align="center">
              <div class="d-flex align-items-center">
                <div
                  :class="[
                    getStatusColorClass(jobAd.status),
                    'flex-shrink-0',
                    'stage-size',
                    'rounded-circle',
                    'mr-2',
                  ]"
                ></div>
                <span
                  :class="[
                    getStatusTitle(jobAd.status).status !== '' ? 'text-nowrap' : 'mr-0',
                    'stage-text',
                  ]"
                  >{{ getStatusTitle(jobAd.status).status }}</span
                >
              </div>
            </td>
            <td id="pipeline-statistics">
              <!-- TODO: integrate custom statistics component -->
              <!--  <PipelineStats
                :statistics="[{ id: 1, num: 21, label: 'Not contacted' }]"
              ></PipelineStats> -->
              <ul
                v-if="jobAd.statistics"
                class="stats-labels d-none d-sm-none d-xs-none d-md-none d-lg-none d-xl-flex"
              >
                <li
                  v-show="
                    jobAd.statistics.not_contacted !== 0 && jobAd.statistics.not_contacted !== null
                  "
                  class="stats-labels-item color-grey"
                >
                  <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                    <div class="popper">Not contacted</div>
                    <router-link to slot="reference" class="text-white">{{
                      jobAd.statistics.not_contacted
                    }}</router-link>
                  </popper>
                </li>
                <li
                  v-show="jobAd.statistics.contacted !== 0 && jobAd.statistics.contacted !== null"
                  class="stats-labels-item color-light-grey"
                >
                  <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                    <div class="popper">Contacted</div>
                    <router-link to href slot="reference" class="text-white">{{
                      jobAd.statistics.contacted
                    }}</router-link>
                  </popper>
                </li>
                <li
                  v-show="
                    jobAd.statistics.interviewing !== 0 && jobAd.statistics.interviewing !== null
                  "
                  class="stats-labels-item color-blue"
                >
                  <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                    <div class="popper">Interviewing</div>
                    <router-link to href slot="reference" class="text-white">{{
                      jobAd.statistics.interviewing
                    }}</router-link>
                  </popper>
                </li>
                <li
                  v-show="
                    jobAd.statistics.offered_employment !== 0 &&
                      jobAd.statistics.offered_employment !== null
                  "
                  class="stats-labels-item color-light-blue"
                >
                  <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                    <div class="popper">Offered employment</div>
                    <router-link to href slot="reference" class="text-white">{{
                      jobAd.statistics.offered_employment
                    }}</router-link>
                  </popper>
                </li>
                <li
                  v-show="jobAd.statistics.employed !== 0 && jobAd.statistics.employed !== null"
                  class="stats-labels-item color-green"
                >
                  <popper :append-to-body="true" trigger="hover" :options="{ placement: 'top' }">
                    <div class="popper">Employed</div>
                    <router-link to href slot="reference" class="text-white">{{
                      jobAd.statistics.employed
                    }}</router-link>
                  </popper>
                </li>
              </ul>
              <span v-else>N/A</span>
            </td>
          </tr>
        </tbody>
      </table>

      <ErrorList
        class="no-data-message"
        v-show="getJobAds.length == 0"
        name="noJobs"
        :phrase="searchText"
      />
    </div>

    <div class="bottom-controls ml-auto mt-auto w-10">
      <div id="pagination">
        <!-- Pagination -->
        <Pagination
          :currentPage="getCurrentPage"
          :totalPages="getTotalPages"
          @nextPage="nextPage"
          @prevPage="previousPage"
          @keyup="keymonitor"
          @selectPageByNumber="setPageBynumber"
          @firstPage="setToFirstPage"
          @lastPage="setToLastPage"
        ></Pagination>
      </div>
    </div>
    <portal-target name="add-job-modal"></portal-target>
  </div>
</template>

<script>
import axios from 'axios';
import { statusMapper /* , redirectToHome */ } from '@/utils/helpers';

import { mapGetters, mapActions } from 'vuex';

import Pagination from '@/components/Navigations/Pagination';
// import AddBtn from '../common/TableControlsAddBtn';
import { errorService } from '../../../services/errorService';

import Search from '../../common/Search/Search';

import AddJobBtnModal from './AddJobBtnModal';
import CustomMainModal from '../../Modals/CustomMainModal';

/* import PipelineStats from '../../common/PipelineStatistics/PipelineStatistics'; */

import { stagesMixin } from '../../../mixins/stagesMixin';
import { statusMixin } from '../../../mixins/statusMixin';
import { displayResultsBasedOnScreenHeightMixin } from '../../../mixins/displayResultsBasedOnScreenHeightMixin';
import { serviceLevelMixin } from '../../../mixins/serviceLevelMixin';
import MESSAGES from '../../../constants/messages';
import ErrorList from '@/components/common/errorsList';
import titleMixin from '../../../mixins/titleMixin';

export default {
  props: {
    isVisible: {
      type: String,
      default: '',
    },
  },
  mixins: [
    stagesMixin,
    statusMixin,
    displayResultsBasedOnScreenHeightMixin,
    serviceLevelMixin,
    titleMixin,
  ],
  title() {
    return 'Jobs | Jobshark';
  },
  components: {
    CustomMainModal,
    Pagination,
    Search,
    AddJobBtnModal,
    ErrorList,

    /*  PipelineStats, */
  },
  data: () => ({
    reloadKey: 0,
    /* Filters */
    locationsOptions: [],
    citiesByNameOptions: [],
    selectedFilterName: [],
    filters: [],
    listOfFilters: [],
    /* End Filters */
    stylesObj: {
      boxShadow: '',
    },
    listOfSelectedEmployers: [],
    serviceLevelSelectModel: [],
    selectedFiltersList: [],
    searchText: '',
    infiniteScrollList: [],
    toggleFilter: false,
    showModal: false,
    isPublished: '',
    currentPage: 1,
    searchWord: '',
    pageCount: 10,
    isLoading: false,
    promoted: false,
    published: false,
    showLabel: false,
    isApplyFiltersDisabled: false,
    promotedState: false,
  }),
  methods: {
    ...mapActions([
      'retrieveEmployersDropdown',
      'retrieveCompetencesList',
      'searchLocationByName',
      'retrieveAllCountries',
      'retrieveJobAds',
    ]),
    onCloseAddJobModal() {
      this.showModal = false;

      // location.reload();
    },

    checkSearch() {
      if (this.searchWord === '') {
        this.doSearch(this.searchWord);
      }
    },

    getRouteByRole(role, jobAd) {
      switch (role) {
        case 'admin':
          return {
            name: 'job_uuid',
            params: { job_uuid: jobAd.id, job_name: jobAd.title },
          };
        case 'recruiter':
          return {
            name: 'recruiter_job_uuid',
            params: {
              job_uuid: jobAd.id,
              recruiter_job_name: jobAd.title,
            },
          };
      }
    },
    getLocation(city, country) {
      if (city.hasOwnProperty('name') && country.hasOwnProperty('name')) {
        return `${city.name}, ${country.name}`;
      }

      return '';
    },
    changePromotedState() {
      this.promotedState = !this.promotedState;
    },
    /* Filters */
    toggleLabel(e) {
      e.target.value ? (this.showLabel = true) : (this.showLabel = false);

      if (e.target.value && e.target.value <= 0) {
        this.isApplyFiltersDisabled = true;

        this.$toasted.error(MESSAGES.notValidDistance, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      } else {
        this.isApplyFiltersDisabled = false;
      }
    },
    selectedFilterType(e) {
      if (e.target.value == 'distance') {
        this.filters.forEach(el => {
          if (el && Object.keys(el).length === 0) {
            el['distance'] = 100;
            this.showLabel = true;
          }
        });
      }

      if (e.target.value == 'employment') {
        this.filters.forEach(el => {
          if (el && Object.keys(el).length === 0) {
            el['employment'] = '1';
          }
        });
      }

      if (e.target.value == 'relocation') {
        this.filters.forEach(el => {
          if (el && Object.keys(el).length === 0) {
            el['relocation'] = false;
          }
        });
      }
    },
    handleVSelectFields(inputValue, filterType) {
      return {
        inputValue,
        filterType,
      };
    },
    fetchOptions(search, loading) {
      if (search.length < 3) {
        this.locationsOptions = [];
      }

      if (search.length >= 3) {
        loading(true);

        this.searchLocationByName(search)
          .then(response => {
            const citiesList = response.data.cities;
            const countriesList = response.data.countries;

            const concatedLists = [].concat(countriesList, citiesList);

            this.locationsOptions = concatedLists;

            loading(false);
          })
          .catch(err => {
            loading(false);
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
    fetchOptionsForCities(search, loading) {
      if (search.length > 1) {
        loading(true);
        this.searchLocationByName(search)
          .then(response => {
            this.citiesByNameOptions = response.data.cities;

            loading(false);
          })
          .catch(err => {
            loading(false);
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
    addFilter(_value, fieldType) {
      fieldType.push({});
      this.selectedFilterName.push('location');
    },
    removeSingleFilter(index, fieldType) {
      fieldType.splice(index, 1);
      this.selectedFilterName.splice(index, 1);

      this.reloadDefaultList();
    },
    removeAllFilters() {
      this.filters = [];
      this.selectedFilterName = [];

      this.reloadDefaultList();
    },
    applyFilters() {
      // Remove invalid entries
      this.selectedFilterName.forEach((filterType, index) => {
        if (filterType == 'distance') {
          Object.keys(this.filters[index] || {}).forEach(key =>
            this.selectedFilterName.includes(key),
          );
        } else {
          Object.keys(this.filters[index] || {}).forEach(
            key => this.selectedFilterName.includes(key) || delete this.filters[index][key],
          );
        }
      });

      this.filters.forEach(item => {
        if (item['location']) {
          let tempList = item.location.map(i => i.id);

          this.listOfFilters.push({ location: tempList });

          //         console.log('location: ', this.listOfFilters);
        }

        if (item['city']) {
          this.listOfFilters.push({
            distance: {
              city_id: item['city'].id,
              distance: item['distance'] || 0,
            },
          });

          //         console.log('city: ', this.listOfFilters);
        }

        if (item['employment']) {
          this.listOfFilters.push({
            employment: Number(item.employment),
          });

          //       console.log('Employment type: ', this.listOfFilters);
        }

        if (item['competences']) {
          this.listOfFilters.push(item);

          //       console.log('competences: ', this.listOfFilters);
        }

        if (item['relocation'] == true || item['relocation'] == false) {
          //     console.log('relocation: ', item);

          this.listOfFilters.push({
            relocation: item.relocation,
          });

          /*       console.log('relocation: ', this.listOfFilters); */
        }
      });

      // console.log('final: ', this.listOfFilters);

      this.doSearchWithFilters(this.listOfFilters);

      //Reset List
      this.listOfFilters = [];
    },
    reloadDefaultList() {
      this.isLoading = true;

      this.selectedFiltersList = [];
      this.currentPage = 1;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }

      this.retrieveJobAds({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        published: this.published,
        promoted: this.promoted,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        /*  filters: filters, */
        filters: [],
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          if (err.response.status == 401) {
            this.$toasted.error(MESSAGES.expiredSession, {
              theme: 'bubble',
              icon: 'fa-check-circle',
              position: 'bottom-right',
              duration: 5000,
            });

            this.$router.push({ name: 'home' });
            location.reload();
          }

          this.isLoading = false;
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    doSearchWithFilters(filters) {
      this.isLoading = true;
      this.currentPage = 1;

      this.selectedFiltersList = filters;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }

      this.retrieveJobAds({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        published: this.published,
        promoted: this.promoted,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        filters: filters,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    /* End Filters */
    doSearch(searchedText) {
      /*    console.log('searchedText: ', searchedText); */

      this.currentPage = 1;

      if (searchedText.length >= 2) {
        this.isLoading = true;

        this.searchText = searchedText;

        if (this.isPublished.includes('Published')) {
          this.published = true;
        } else {
          this.published = false;
        }

        if (this.isPublished.includes('Promoted')) {
          this.promoted = true;
        } else {
          this.promoted = false;
        }

        this.retrieveJobAds({
          search_word: searchedText,
          page: this.currentPage,
          count: this.pageCount,
          published: this.published,
          promoted: this.promoted,
          employersList: this.listOfSelectedEmployers.map(item => item.id),
          service_level: this.serviceLevelSelectModel.map(item => item.id),
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }

      if (searchedText === '') {
        this.isLoading = true;
        this.searchText = searchedText;

        if (this.isPublished.includes('Published')) {
          this.published = true;
        } else {
          this.published = false;
        }

        if (this.isPublished.includes('Promoted')) {
          this.promoted = true;
        } else {
          this.promoted = false;
        }

        this.retrieveJobAds({
          search_word: searchedText,
          page: this.currentPage,
          count: this.pageCount,
          published: this.published,
          promoted: this.promoted,
          employersList: this.listOfSelectedEmployers.map(item => item.id),
          service_level: this.serviceLevelSelectModel.map(item => item.id),
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    infiniteHandler($state) {
      axios
        .get(`https://test4shark.jobshark.se/api/jobadsList`, {
          params: {
            page: this.currentPage,
            count: this.pageCount,
          },
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          /*   console.log(data); */
          const list = data.data.result.data;

          if (list.length) {
            this.currentPage += 1;
            this.infiniteScrollList.push(...list);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    },
    handleSearchFilters() {
      this.isLoading = true;

      // Reset current page to 1
      this.currentPage = 1;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }

      this.retrieveJobAds({
        page: this.currentPage,
        count: this.pageCount,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        filters: this.filters,
        published: this.published,
        promoted: this.promoted,
      })
        .then(() => {
          this.currentPage = 1;

          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;

          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    nextPage() {
      if (this.currentPage >= 1 && this.currentPage < this.getTotalPages) {
        this.isLoading = true;
        this.currentPage++;

        if (this.isPublished.includes('Published')) {
          this.published = true;
        } else {
          this.published = false;
        }

        if (this.isPublished.includes('Promoted')) {
          this.promoted = true;
        } else {
          this.promoted = false;
        }

        this.retrieveJobAds({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
          employersList: this.listOfSelectedEmployers.map(item => item.id),
          service_level: this.serviceLevelSelectModel.map(item => item.id),
          filters: this.selectedFiltersList,
          published: this.published,
          promoted: this.promoted,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        if (this.isPublished.includes('Published')) {
          this.published = true;
        } else {
          this.published = false;
        }

        if (this.isPublished.includes('Promoted')) {
          this.promoted = true;
        } else {
          this.promoted = false;
        }

        this.retrieveJobAds({
          search_word: this.searchText,
          page: this.currentPage,
          count: this.pageCount,
          published: this.published,
          promoted: this.promoted,
          employersList: this.listOfSelectedEmployers.map(item => item.id),
          service_level: this.serviceLevelSelectModel.map(item => item.id),
          filters: this.selectedFiltersList,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(err => {
            this.isLoading = false;
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }

      this.retrieveJobAds({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        published: this.published,
        promoted: this.promoted,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        filters: this.selectedFiltersList,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }
      this.retrieveJobAds({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        published: this.published,
        promoted: this.promoted,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        filters: this.selectedFiltersList,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    setPageBynumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.currentPage = pageNumber;

      if (this.isPublished.includes('Published')) {
        this.published = true;
      } else {
        this.published = false;
      }

      if (this.isPublished.includes('Promoted')) {
        this.promoted = true;
      } else {
        this.promoted = false;
      }
      this.retrieveJobAds({
        search_word: this.searchText,
        page: this.currentPage,
        count: this.pageCount,
        published: this.published,
        promoted: this.promoted,
        employersList: this.listOfSelectedEmployers.map(item => item.id),
        service_level: this.serviceLevelSelectModel.map(item => item.id),
        filters: this.selectedFiltersList,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    handleScroll(evt) {
      if (evt.target.scrollLeft > 0) {
        this.stylesObj.boxShadow = 'rgba(0,0,0,0.75) 7px 8px 17px -14px';
      } else {
        this.stylesObj.boxShadow = '';
      }
    },

    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight' && !this.showModal) {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft' && !this.showModal) {
        this.previousPage();
      }
    },
  },
  watch: {
    showModal() {
      // document.body.style.overflow = this.showModal ? 'hidden' : '';
    },
  },
  computed: {
    ...mapGetters([
      'getToken',
      'getJobAds',
      'getNextPage',
      'getTotalPages',
      'getUserProfile',
      'getCurrentPage',
      'getCitiesByName',
      'getAllCountries',
      'getEmployersDropdown',
      'getCompetencesFilterList',
      'getAccType',
    ]),
    getStatus() {
      return statusMapper('6');
    },
  },

  mounted() {
    this.isLoading = true;

    this.displayResultsBasedOnScreen();

    if (this.isPublished.includes('Published')) {
      this.published = true;
    } else {
      this.published = false;
    }

    if (this.isPublished.includes('Promoted')) {
      this.promoted = true;
    } else {
      this.promoted = false;
    }

    this.retrieveJobAds({
      search_word: this.searchText,
      page: 1,
      count: this.pageCount,
      published: this.published,
      promoted: this.promoted,
    })
      .then(() => {
        this.isLoading = false;
      })
      .catch(err => {
        this.isLoading = false;

        this.$toasted.error(errorService(err), {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      });

    this.retrieveEmployersDropdown();
    this.retrieveCompetencesList();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_mixins.scss';

.custom-label {
  line-height: 40px;
  position: absolute;
  right: 70px;
  top: 0;
  bottom: 0;
  -moz-transition: 0.3s right ease;
  -ms-transition: 0.3s right ease;
  -o-transition: 0.3s right ease;
  -webkit-transition: 0.3s right ease;
  transition: 0.3s right ease;
  z-index: 0;
}

.btn-success {
  align-self: start;
}

.m-button {
  display: none;
}

.published {
  margin-top: 8px;
}

.truncate-item {
  a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
}

.custom-table {
  min-width: 100%;
  tr {
    td {
      &:first-of-type {
        padding-left: 21px;
      }
    }
  }
}

.table-responsive {
  overflow-y: auto;
  position: relative;
}

select {
  min-width: 110px;
  box-shadow: 0px 2px 3px #0000000d;
  border: 1px solid #d7dae2;
  border-radius: 4px;
}

#stage {
  .stage-size {
    width: 12px;
    height: 12px;
  }

  .stage-color-new {
    background-color: #4ca7d5;
  }
  .stage-color-draft {
    background-color: #8a8b8a;
  }
  .stage-color-active {
    background-color: #419941;
  }
  .stage-color-expired {
    background-color: #f17931;
  }
  .stage-color-rejected {
    background-color: #f02800;
  }
}

/* Pipeline statistics */
#pipeline-statistics {
  position: relative;

  .stats-labels {
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translate(0%, -50%);
    opacity: 0.75;
    list-style-type: none;
    margin: 0;
    padding: 0;
    font-family: Lato;
    font-size: 11px;

    .stats-labels-item {
      span {
        padding: 5px;
        color: #fff;
      }

      // float: left;
      clip-path: polygon(85% 0, 100% 50%, 85% 100%, 0 100%, 10% 50%, 0 0);
      // height: 8px;
      padding: 0.4rem 1rem 0.4rem 1rem;
      margin-right: -10px;
    }

    .color-grey {
      background: #333;
    }

    .color-light-grey {
      background: #747674;
    }

    .color-blue {
      background: #465c74;
    }

    .color-light-blue {
      background: #066da1;
    }

    .color-green {
      background: #148214;
    }

    .color-light-green {
      background: #5bb75b;
    }

    .color-dark-red {
      background: #913d8b;
    }

    .color-red {
      background: #f02800;
    }

    span:nth-child(1) {
      font-size: 14px;
      font-weight: bold;
      margin-right: 10px;
    }

    span:nth-child(2) {
      font-weight: 300;
    }
  }
}

/* #col-title,
#title:not([data-scroll='0']) {
  -webkit-box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 5px 17px -14px rgba(0, 0, 0, 0.75);
} */
.published-mobile {
  display: none !important;
}

.employer-select {
  flex: 1;
}

.mobile-only {
  display: none !important;
}

.desktop-only {
  display: block;
}
.desktop-only-table {
  display: table;
}
.service-level-select,
.employer-level-select {
  width: 50%;
}

.card {
  height: 81.7vh;
  padding-bottom: 0 !important;
}

@media only screen and(max-width: 576px) {
  .card {
    margin-top: 0px;
  }
  .table-controls {
    display: flex;
    .controls-wrap {
      flex-wrap: wrap;
      width: 100%;
      .form-control {
        width: 100%;
        margin-right: 0 !important;
        margin: 0 0 12px 0;
        border-radius: 0;
      }
      #integration-search {
        border-radius: 0;
      }
      .btn-outline,
      .popperr,
      .btn-success {
        display: none;
      }
      .d-flex {
        width: 100%;
        .empl {
          width: 33%;
          &:nth-of-type(3) {
            margin-right: 0 !important;
          }
        }
      }
    }
  }
  .custom-table {
    display: block;
  }
}

@media only screen and(min-width: 576px) and (max-width: 768px) {
  .table-controls {
    display: block;
    .controls-wrap {
      flex-wrap: wrap;
      width: 100%;
      .form-control {
        width: 100%;
        margin-right: 0 !important;
        margin: 0 0 12px 0;
        border-radius: 0;
      }
      #integration-search {
        border-radius: 0;
      }
      .btn-success,
      .popperr {
        display: none;
      }
      .d-flex {
        width: 100%;
        .empl {
          width: 33%;
          &:nth-of-type(3) {
            margin-right: 0 !important;
          }
        }
      }
    }
  }
  .custom-table {
    display: block;
    width: 100%;
  }
}
@media only screen and(min-width: 768px) and (max-width: 992px) {
  .custom-table {
    display: block;
    width: 100%;
  }
}
@media only screen and(min-width: 992px) and (max-width: 1150px) {
  .custom-table {
    display: block;
    width: 100%;
  }
}

@media only screen and (max-width: 576px) {
  .card {
    margin-top: 0px !important;
  }

  .mobile-only {
    display: block !important;
  }
  .service-level-select {
    margin-right: 0 !important;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1251px) {
  .card {
    margin: 24px 23px 0 23px !important;
  }
}

@media only screen and (max-width: 992px) {
  .m-button {
    display: inline-block;
    float: right;
    margin-top: 12px;
  }
  .card {
    border-top-left-radius: 18px !important;
    border-top-right-radius: 18px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .mobile-only {
    display: block !important;
  }
  .desktop-only {
    display: none;
  }
  .desktop-only-table {
    display: none;
  }
  .wrapper {
    width: 100%;
  }
  .service-level-select {
    margin-top: 12px;
  }
  .employer-level-select {
    margin-top: 12px;
  }
}

@media only screen and (max-width: 768px) {
  .mobile-only {
    display: block !important;
  }
  .desktop-only {
    display: none;
  }
  .desktop-only-table {
    display: none;
  }
  .service-level-select,
  .employer-level-select {
    width: 100%;
  }
}

@media screen and (max-width: 1200px) {
  .stats-labels-data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.vs--searchable .vs__dropdown-toggle {
  height: calc(1.5em + 0.75rem + 2px);
}

.col-md-8.filter {
  color: #6c757d;
  margin-bottom: 12px;
  font-family: $font-family-sans-lato;
}

.filter-select {
  min-width: 200px;
  max-width: 200px;
  margin-right: 6px !important;
  padding-bottom: 8px;
}
</style>
